import React, { Component,useEffect,useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config.js'
import { APP_BASE_URL } from '../../../config.js'
// import { toast } from 'react-toastify';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';

import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

import { Accordion } from 'react-bootstrap-accordion'
import 'react-bootstrap-accordion/dist/index.css'

const ChangeProfile = () => {
 const [data, setData] = useState({ exit_types: [] });
  const [exitType, setExitType] = useState("");
  const [data1, setData1] = useState([]);
  const [reason, setReason] = useState('');
  const [answers, setAnswers] = useState({});
  const [cnt, setCnt] = useState(null);
   const [error, setError] = useState(null);

  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const token = localStorage.getItem('authToken');


  const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage,setEntriesPerPage]=useState(10);
    let filteredItems = data1.filter((item) =>
  
  
  
      `${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())
  
    );
    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
  
    const startIndex = (currentPage - 1) * entriesPerPage;
  
  
    useEffect(() => {
      setCurrentPage(1);
    }, [searchTerm]);
  
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    const handleSearch = (event) => {
      setSearchTerm(event.target.value);
    };
  
  
    const clearInput = () => {
      setSearchTerm("");
      };
  


  useEffect(()=> {
    axios.get(API_BASE_URL +'/get_exittype', {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
  
    // .then(res =>console.log(res.data))
     .then(res => setData(res.data))
    .catch(err => console.log(err));
  },[]);

    const[emp_id,setEmpId]=useState("");
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [fetchprofile,fetchProfilePicture]= useState("");


	useEffect(() => {
		axios.get(API_BASE_URL + '/showemployeeinfo', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			// .then(res =>console.log(res.data.profile_picture))
			.then(res1 => setEmpId(res1.data.user_id))
			.then(res => fetchProfilePicture(res.data.profile_picture))
			.catch(err => console.log(err));
	}, [])

  const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file) {
		  setImage(file);
		//   setPreview(URL.createObjectURL(file)); // Preview image
		}
	  };


      const imagepath=APP_BASE_URL+'/aah-api/uploads/profile/'+fetchprofile;

const handleProfileSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/profilepicture', { image: image,id:emp_id}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


const [newpassword,setNewPassword]= useState("");
	const [confirmnewpassword,setConfirmNewPassword]= useState("");


	const handleNewPasswordChange = (event) => {
		const value = event.target.value;
		setNewPassword(value);
	
	  };


	  const handleConfirmNewPasswordChange = (event) => {
		const value = event.target.value;
		setConfirmNewPassword(value);
	
	  };

	const handleChangePaswordSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/changepassword', { password: newpassword,confirm_password:confirmnewpassword,id:emp_id}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};










  return (
    <div className="container mt-3">
    <ToastContainer/>

    
     <div className="card-body" >

      {/* Exit Procedure Form */}
      <Accordion title="Profile Picture">
	  
											<div className="container-fluid">
																<div className="row clearfix">
																	<div className="col-md-12">
																		<div className="card">
	  
	  
											<div className="card-body">
												
	  
												<form onSubmit={handleProfileSubmit}>
													<div class="row">
											<div className="col-md-3 col-sm-12">
													<div className="form-group">
													<label className="form-label">Browse <span className="form-required">*</span></label>
													
													<input type="file" accept="image/*" onChange={handleImageChange} className="block w-full" />
			  
													{/* {preview && <img src={preview} alt="Preview" className="h-40 w-40 object-cover mt-2" />} */}
													
													{fetchprofile!='' && <img src={imagepath} alt="Preview" className="h-40 w-40 object-cover mt-2" />}
													
												</div>
											</div>
	  
											
	  
											</div>
	  
											<div class="row">
	  
													<div className="form-footer">
														<button className="btn btn-primary btn-block">Save</button>
													</div>
													</div>
	  
											</form>
											</div>
											</div>
											</div>
											</div>
											</div>
	  
											</Accordion>


											<Accordion title="Change Password">
											
																				<div className="container-fluid">
																									<div className="row clearfix">
																										<div className="col-md-12">
																											<div className="card">
											
											
																				<div className="card-body">
																					{/* <form onSubmit={handleapprovalSubmit}> */}
											
																					<form onSubmit={handleChangePaswordSubmit}>
																						<div class="row">
																				<div className="col-md-3 col-sm-12">
																						<div className="form-group">
																						<label className="form-label">Password <span className="form-required">*</span></label>
											
																						<input class="form-control" placeholder="" name="newpassword" type="text" value={newpassword} onChange={handleNewPasswordChange}/>
																					</div>
																				</div>
											
																				<div className="col-md-3 col-sm-12">
																						<div className="form-group">
																						<label className="form-label">Confirm Passord <span className="form-required">*</span></label>
											
																						<input class="form-control" placeholder="" name="confirmnewpassword" type="text" value={confirmnewpassword} onChange={handleConfirmNewPasswordChange}/>
																					</div>
																				</div>
											
																				</div>
											
																				<div class="row">
											
																						<div className="form-footer">
																							<button className="btn btn-primary btn-block">Save</button>
																						</div>
																						</div>
											
																				</form>
																				</div>
																				</div>
																				</div>
																				</div>
																				</div>
											
											</Accordion>

	</div>


   



    </div>
  );
};

export default ChangeProfile;
